module.exports = __webpack_public_path__ + "img/fulmekiola-serrata.c1861f41.jpg";